import { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '@/config/firebase'
import type { ProjectDoc } from '@/types/project'
import type { ProjectRecord } from './useProjects'

interface ProjectState {
  project: ProjectRecord | null
  loading: boolean
  error: string | null
}

/** Realtime single project by id (access enforced by firestore.rules). */
export function useProject(id: string): ProjectState {
  const [state, setState] = useState<ProjectState>({ project: null, loading: true, error: null })

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'projects', id),
      (snapshot) => {
        setState({
          project: snapshot.exists()
            ? { id: snapshot.id, ...(snapshot.data() as ProjectDoc) }
            : null,
          loading: false,
          error: null,
        })
      },
      (error) => setState({ project: null, loading: false, error: error.message }),
    )
    return unsubscribe
  }, [id])

  return state
}
